import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=ca8976d2&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=ts&"
export * from "./ColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=ca8976d2&scoped=true&lang=scss&"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8976d2",
  null
  
)

export default component.exports